// Profile and external links, rendered with icons in the Footer and Contact page.
// `icon` maps to an entry in components/ProfileLinks.js
export const profileLinks = [
  {
    id: 1,
    label: "Google Scholar",
    icon: "scholar",
    href: "https://scholar.google.com/citations?user=L_ctqf0AAAAJ&hl=en",
  },
  {
    id: 7,
    label: "ORCID",
    icon: "orcid",
    href: "https://orcid.org/0000-0003-1140-8119",
  },
  {
    id: 2,
    label: "LinkedIn",
    icon: "linkedin",
    href: "https://www.linkedin.com/in/abdullah-al-redwan-newaz-5ba849130/",
  },
  {
    id: 3,
    label: "Faculty Profile",
    icon: "faculty",
    href: "https://www.lsuneworleans.edu/profile/faculty/abdullah-al_redwan-newaz",
  },
  {
    id: 4,
    label: "GitHub",
    icon: "github",
    href: "https://github.com/AiRLab-UNO",
  },
  {
    id: 5,
    label: "Research Dashboard",
    icon: "dashboard",
    href: "https://research-dashboard-pied.vercel.app/signin",
  },
  {
    id: 6,
    label: "Email",
    icon: "email",
    href: "mailto:aredwann@lsuneworleans.edu",
  },
];

export const labInfo = {
  name: "Autonomous Intelligent Robotics (AiR) Laboratory",
  department: "Department of Computer Science",
  institution: "LSU New Orleans",
  addressLines: [
    "Mathematics Building 345",
    "2000 Lakeshore Drive",
    "New Orleans, LA 70148",
  ],
  phone: "504-280-4409",
  email: "aredwann@lsuneworleans.edu",
  orcid: "0000-0003-1140-8119",
  orcidUrl: "https://orcid.org/0000-0003-1140-8119",
};

